/**
 * Calculates the difference between 2 dates in milliseconds
 *
 * @param {Date} d1
 * @param {Date} d2
 *
 * @return {Number} Difference in milliseconds
 */
function dateDiffInMilliseconds(d1, d2) {
    return new Date(d1) - new Date(d2);
}

const dateDiff = [
    { key: "days", denominator: 1000 * 60 * 60 * 24 },
    { key: "hours", denominator: 1000 * 60 * 60 },
    { key: "minutes", denominator: 1000 * 60 },
    { key: "seconds", denominator: 1000 },
].reduce((a, c) => {
    a[c.key] = function(d1, d2) {
        return dateDiffInMilliseconds(d1, d2) / c.denominator;
    };
    return a;
}, {});

export default dateDiff;

export { dateDiffInMilliseconds as __test__dateDiffInMilliseconds };
